/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	export class ActivityPhoto {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(json:object) {
			this.thumbnailUrl = json['thumb_square_small_url'];
			const thumbnailSize:number[] = json['px_size_thumb_square'];
			if (thumbnailSize !== null) {
				this.thumbnailWidth = thumbnailSize[0];
				this.thumbnailHeight = thumbnailSize[1];
			} else {
				this.thumbnailWidth = 0;
				this.thumbnailHeight = 0;
			}

			this.imageUrl = json['url'];
			const imageSize:number[] = json['px_size'];
			if (imageSize !== null) {
				this.imageWidth = imageSize[0];
				this.imageHeight = imageSize[1];
			} else {
				this.imageWidth = 0;
				this.imageHeight = 0;
			}

			this.caption = json['caption'];

			const coordinate:number[] = json['coord'];
			this.hasCoordinate = coordinate !== null;
			if (this.hasCoordinate) {
				this.position = new LatLng(coordinate[1], coordinate[0]);
				this.altitude = json['altitude'];
			} else {
				this.position = null;
				this.altitude = null;
			}

			this.takenAt = json['taken_at'] * 1000;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getThumbnailUrl():string {
			return this.thumbnailUrl;
		}

		public getThumbnailWidth():number {
			return this.thumbnailWidth;
		}

		public getThumbnailHeight():number {
			return this.thumbnailHeight;
		}

		public getImageUrl():string {
			return this.imageUrl;
		}

		public getImageWidth():number {
			return this.imageWidth;
		}

		public getImageHeight():number {
			return this.imageHeight;
		}

		public getCaption():string {
			return this.caption;
		}

		public getHasCoordinate():boolean {
			return this.hasCoordinate;
		}

		public getPosition():LatLng {
			return this.position;
		}

		public getAltitude():number {
			return this.altitude;
		}

		public getTakenAt():number {
			return this.takenAt;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private thumbnailUrl:string;
		private thumbnailWidth:number;
		private thumbnailHeight:number;

		private imageUrl:string;
		private imageWidth:number;
		private imageHeight:number;

		private caption:string;

		private hasCoordinate:boolean;
		private position:LatLng;
		private altitude:number;

		private takenAt:number;
	}
}
